import React from 'react';
import { TrendingUp, ArrowRight } from 'lucide-react';
import { useForms } from '../../context/FormsContext';
import useReveal from '../../hooks/useReveal';

function Gauge({ type, title, formKey }) {
  const { startMotivation } = useForms();
  return (
    <div className="ckr-card ckr-motivation-card" style={{ padding: 'clamp(16px, 3vw, 28px)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
        <TrendingUp size={18} style={{ color: 'var(--ckr-gold)' }} />
        <h3 style={{ fontSize: 20, fontWeight: 600, color: '#f3efe6', margin: 0 }}>{title}</h3>
      </div>
      <p style={{ fontSize: 14, color: 'rgba(233,235,228,0.64)', marginTop: 0, marginBottom: 22 }}>
        {type === 'satici' ? 'Satış kararınızı, fiyat yaklaşımınızı ve işlem hazırlığınızı birlikte değerlendirin.' : 'Satın alma kararınızı, bütçenizi ve işlem hazırlığınızı birlikte değerlendirin.'}
      </p>
      <p style={{ fontSize: 14.5, color: '#e9ebe4' }}>Sekiz soru · Tek hazırlık puanı · Size özel değerlendirme</p>
      <button type="button" className="ckr-btn ckr-btn-ghost" style={{ marginTop: 18, width: '100%' }} onClick={() => startMotivation(formKey)}>
        Detaylı Analize Geç <ArrowRight size={16} />
      </button>
    </div>
  );
}

export default function Motivation() {
  useReveal();
  return (
    <section id="motivasyon" className="ckr-section" style={{ background: 'transparent' }}>
      <div className="ckr-container">
        <div className="ckr-fade-up" style={{ maxWidth: 640, marginBottom: 44 }}>
          <span className="ckr-eyebrow">Motivasyon Ölçümü</span>
          <h2 style={{ fontSize: 'clamp(25px, 2.8vw, 34px)', fontWeight: 600, color: '#f3efe6', marginTop: 12, marginBottom: 14 }}>
            Kararın ilk adımı: niyetinizi netleştirin
          </h2>
          <p style={{ fontSize: 17, color: 'rgba(233,235,228,0.64)', margin: 0 }}>
            Alıcı ve satıcı motivasyonunuzu kısaca ölçelim. Bu, hangi adımdan başlayacağımızı ve stratejiyi belirler.
          </p>
        </div>
        <div className="ckr-fade-up" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))', gap: 'var(--ckr-grid-gap, 24px)' }}>
          <Gauge type="satici" title="Satıcı Motivasyonu" formKey="satici" />
          <Gauge type="alici" title="Alıcı Motivasyonu" formKey="alici" />
        </div>
      </div>
    </section>
  );
}
